export default __webpack_public_path__ + "static/media/kaus-carousel-5.cb8fe168.jpg";